import React from "react";

function ViewTestimonial({ data }) {

  return (
    <div className="custom-modal-body">

      <div className="model-custum text-center">

        <img
          src={data?.image}
          alt={data?.name}
          className="testimonial-view-img"
        />

        <h3>
          {data?.name}
        </h3>

        <p className="testimonial-designation">
          {data?.designation}
        </p>

        <div
          className={
            data?.status === "Active"
              ? "view-status-badge active-badge"
              : "view-status-badge inactive-badge"
          }
        >
          {data?.status}
        </div>

        <p className="testimonial-full-desc">
          {data?.description}
        </p>

      </div>

    </div>
  );
}

export default ViewTestimonial;